<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item
            class="QwePhoneField"
            :class="className"
            :label="displayName"
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="data[name]" hidden="hidden">
            <el-input placeholder = "请输入中国大陆手机号"
                class="qweelement phoneNmuber"
                :class="{ 'qwe-field-error' : Error == 1  }"
                v-model.lazy="data[name]"
                :disabled="disabled">
                <template #prefix><el-icon><Iphone /></el-icon></template>
            </el-input>
            <el-input v-if="!disabled"
                placeholder = "请输入验证码"
                class="qweelement"
                :class="{'button-disabled' : computedcheckInButtonDisable, 'qwe-field-error' : Error == 2 }"
                v-model.lazy="checkInCodeInput"
                @input="checkInCodeInputChange"
                :disabled="computedcheckInInputDisable">
                <template #append>
                    <el-button @click="sendVerifierCode" :disabled="computedcheckInButtonDisable"> {{ checkInButton }} </el-button>
                </template>
            </el-input>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
    </el-col>
</template>

<style>
    .qweelement.phoneNmuber{
        margin-bottom: 0.6rem;
    }
    
    .QwePhoneField.el-form-item.is-error .el-input__wrapper{
        box-shadow: 0 0 0 1px var(--el-input-border-color,var(--el-border-color)) inset;
    }

    .QwePhoneField.el-form-item.is-error .el-input.qwe-field-error .el-input__wrapper{
        box-shadow: 0 0 0 1px var(--el-color-danger) inset;
    }

    .QwePhoneField.el-form-item .el-input__wrapper>.el-input__suffix{
        display: none;
    }

    .QwePhoneField .el-form-item__content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .QwePhoneField .el-input-group__append{
        background-color: white;
        color: rgb(96, 98, 102);
    }
    .QwePhoneField .button-disabled .el-input-group__append{
        background-color: rgb(245, 247, 250);
        color: rgb(168, 171, 178);
    }
</style>

<script>
    import qweBaseField from "../BaseField"
    import { Iphone } from "@element-plus/icons-vue"
    import { sendCode, checkCode } from "../../../apis/httpHelper"
    import { qweIsEmpty, qweLeft } from "../../../common/commonHelper";

    export default{
        mixins:[qweBaseField],

        name:"PhoneField",

        components:{
            Iphone:Iphone
        },

        computed:{
            phone:function(){
                return this.data[this.name] || "";
            },

            phoneFinished:function(){
                return this.phone.length == 11;
            },

            computedcheckInButtonDisable:function(){
                if(this.phoneFinished){
                    return this.checkInButtonDisable;
                }
                else{
                    return true;
                }
            }, 

            computedcheckInInputDisable:function(){
                if(this.phoneFinished){
                    return !this.checkInButtonDisable;
                }
                else{
                    return true;
                }
            }
        },


        data:function(){
            return {
                checkInButtonDisable:false,
                checkInButton:"获取验证码",
                checkInCodeInput:"",

                lastCheckInTimer:{},
                lastUpdateDateTimer:{},
                endTime : 60,
                successPhone:"",
                successCode:"",

                Error:0,
                checkInState:false
            }
        },

        methods:{
            buildRequiredRule:function(){
                let self = this;
                let validatePass = (rule, value, callback) => {
                    if (value === null || value === undefined) {
                        callback(new Error('手机号未填写'));
                        self.Error = 1;
                        return;
                    }
                    else {
                        if(!(/^1[3456789]\d{9}$/.test(value))){
                            callback(new Error('手机号填写不规范'));
                            self.Error = 1;
                            return;
                        }
                        if(!self.disabled){
                            if(qweIsEmpty(this.checkInCodeInput)){
                                callback(new Error('未输入验证码'));
                                self.Error = 2;
                                return;
                            }
                            else if(!(this.checkInState && this.successPhone == this.data[this.name] && this.successCode == this.checkInCodeInput)){
                                callback(new Error('验证码输入有误'));
                                self.Error = 2;
                                return;
                            }
                        }
                        self.Error = 0;
                        callback();
                    }
                };
                return {
                    validator: validatePass, trigger: 'blur', required: true
                };
            },


            checkInCodeInputChange:function(){
                if(this.checkInCodeInput.length == 6){
                    checkCode(this.data[this.name], this.checkInCodeInput)
                        .then(x=>{
                            this.successPhone = this.data[this.name];
                            this.successCode = this.checkInCodeInput;
                            this.checkInState = true;
                        })
                        .catch(x=>{
                            this.checkInState = false;
                        });
                }
            },

            customFun: function () {

            },
            
            sendVerifierCode:function(){
                if(!this.computedcheckInButtonDisable){
                    sendCode(this.data[this.name])
                        .then(x=>{
                            this.callback1();
                        });
                }
            },

            callback1:function(){
                this.checkInButtonDisable = true;
                this.endTime = 60;
                this.checkInButton = "重新获取（60s）";
                this.successPhone = "";
                this.successCode = "";

                clearTimeout(this.lastCheckInTimer);
                this.lastCheckInTimer = setTimeout(()=>{
                    clearInterval(this.lastUpdateDateTimer);
                    this.checkInButtonDisable = false;
                    this.checkInButton = "获取验证码";
                },60000);

                clearInterval(this.lastUpdateDateTimer);
                this.lastUpdateDateTimer = setInterval(()=>{
                    this.endTime = this.endTime - 1;
                    this.checkInButton = "重新获取（" + this.endTime+ "s）";
                },1000);
            }
        }
    }
</script>